export default {
    ring: 'focus:ring-2 ring-offset-2 ring-info focus:outline-none',
    outline: 'outline-info focus:outline-2 outline-offset-2',
};
